module.exports = __webpack_public_path__ + "static/media/texture-yellow.edde25c9.png";